import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { searchVendorRateContractItems } from '../../../api/vendorRateContractItem';

import { raiseToast } from '../toast/toast';


export const fetchVendorRateContractItems = createAsyncThunk('user/getVendorRateContractItems', async (params, { dispatch }) => {
    const response = await searchVendorRateContractItems(params)
    if(response.failure){
        dispatch(raiseToast({severity:'error', summary: response.data.error, detail: 'Invalid text', life: 3000}))
        throw Error()
    }
    return response
})

export const vendorRateContractItemsSlice = createSlice({
    name: "user/getVendorRateContractItems",
    initialState: {
        loading: false,
        isInitialLoad: true,
        vendorRateContractItems: [],
        materialDetails: [],
        paginationParams: {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            paginator: true,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "vendorRateContractItemsData",
            searchBy: "",
            searchText: "",
            statusIds: [1],
            dateType: "createdAt"
        },
        searchOptions: [],
        isSearchVisible: true,
        searchConfig: []
    },
    reducers: {
        setInitialLoad: (state, action) => {
            state.isInitialLoad = action.payload
        },
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setSearchConfig: (state, action) => {
            state.searchConfig = action.payload
        },
        updateSearchByParam: (state, action) => {
            const parsedState = JSON.parse(JSON.stringify(state))
            const availableOptions = parsedState.searchConfig.map(eachOption => eachOption.name)
            if(availableOptions.includes(action.payload.searchBy)){
                state.searchParams = {...parsedState.searchParams, ...action.payload}
            } else {
                state.searchParams = {...parsedState.searchParams, searchBy: "all", searchText: ""}
            }
        },
        updateVendorRateContractItems: (state, action) => {
            state.vendorRateContractItems = action.payload
        },
        updateMaterialDetails: (state, action) => {
            state.materialDetails = action.payload
        },
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchVendorRateContractItems.fulfilled, (state, action) => {
                state.loading = false 
                state.vendorRateContractItems  = action.payload.data.data
                state.materialDetails = action.payload.data.materialDetails
                state.paginationParams.pageNo = action.payload.data.pageNo-1
                state.paginationParams.recordsPerPage = action.payload.data.recordsPerPage
                if(action.payload.data.totalRecords || action.payload.data.totalRecords === 0){
                    state.paginationParams.totalRecords = action.payload.data.totalRecords
                    state.paginationParams.excessPagesFound = false
                }
                if(action.payload.data.excessPagesFound || !action.payload.data.excessPagesFound){
                    if(!state.paginationParams.excessPagesFound){
                        state.paginationParams.excessPagesFound = action.payload.data.excessPagesFound
                    }else if(action.payload.data.excessPagesFound === false){
                        state.paginationParams.excessPagesFound = false
                    }
                }
                // if(state.vendorRateContractItems.length){
                //     state.isSearchVisible = false
                // }
            }
        )
        .addCase(
            fetchVendorRateContractItems.pending, (state) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchVendorRateContractItems.rejected, (state) => {
                state.loading = false
                state.vendorRateContractItems = []
                state.paginationParams.totalRecords = 0
            }
        )
    }
})

export const { updateSearchParams, updateSearchOptions, setIsSearchVisible, setSearchConfig, setInitialLoad, updateMaterialDetails, updateVendorRateContractItems } = vendorRateContractItemsSlice.actions

export default vendorRateContractItemsSlice.reducer